import React, { useRef } from 'react';
import styled from 'styled-components';
import ReactImageGallery from 'react-image-gallery';
import { LoaderModal, PageWrapper } from 'components';
import { useGetVehicleByIdQuery } from 'services/api/upload-vehicle';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { ImageCarousel } from '../../Admin/ViewVehicle/components/ImageCarousel';
import { VehicleCharacteristics } from '../../Admin/ViewVehicle/components/VehicleCharacteristics';
import { VehicleInfo } from '../../Admin/ViewVehicle/components/VehicleInfo';
import { VehicleSections } from '../../Admin/ViewVehicle/components/VehicleSections';
import { PaymentInfo } from '../../Admin/ViewVehicle/components/VehicleSaleBlock/PaymentInfo';
import { SaleTerms } from '../../Admin/ViewVehicle/components/VehicleSaleBlock/SaleTerms';
import { SellerAndTransportInfo } from '../../Admin/ViewVehicle/components/VehicleSaleBlock/SellerAndTransportInfo';
import { InspectorComments } from '../../Admin/ViewVehicle/components/InspectorComments';
import { ListerInformation } from '../../Admin/ViewVehicle/components/ListerInformation';
import { FullScreenImageDialog } from '../../Admin/ViewVehicle/components/FullScreenImageDialog';
import { AutoCheckReport } from '../../Admin/ViewVehicle/components/AutoCheckReport';
import { AuctionEndTime } from '../../Admin/ViewVehicle/components/AuctionEndTime';
import { useInitImages } from '../../Admin/ViewVehicle/hooks/useInitImages';
import { PrintView } from '../../Admin/ViewVehicle/components/PrintView';

const StyledPageWrapper = styled(PageWrapper)`
  padding: 12px 16px 40px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 800px;
  margin: 60px auto 0;
  position: relative;
`;

const Wrapper = styled.div`
  position: relative;
`;

export const PublicViewVehicle = () => {
  const vehicleId = useGetVehicleId();
  const { isLoading } = useGetVehicleByIdQuery(vehicleId, { skip: !vehicleId });
  const imageGalleryRef = useRef<ReactImageGallery>(null);

  useInitImages();

  return <MobileView imageGalleryRef={imageGalleryRef} isLoading={isLoading} />;
};

const MobileView = ({
  imageGalleryRef,
  isLoading
}: {
  imageGalleryRef: React.RefObject<ReactImageGallery>;
  isLoading: boolean;
}) => {
  return (
    <Wrapper>
      {!isLoading && (
        <StyledPageWrapper>
          <ImageCarousel imageGalleryRef={imageGalleryRef} maxWidth="800px" />
          <VehicleInfo />
          <AutoCheckReport hideFullReport />
          <AuctionEndTime />
          <VehicleCharacteristics />
          <VehicleSections twoColumnLayout publicView />
          <SellerAndTransportInfo />
          <PaymentInfo />
          <SaleTerms />
          <InspectorComments />
          <ListerInformation />
        </StyledPageWrapper>
      )}
      <LoaderModal modalId={'vehicle_loading'} forceOpen={isLoading} />
      <FullScreenImageDialog imageGalleryRef={imageGalleryRef} />
      <PrintView />
    </Wrapper>
  );
};
